// Resolves `--${stepColor}-600` to a sRGB hex. A sandboxed iframe can't read
// our CSS variables, so we evaluate them here and pass the concrete color down.
export function resolveStepColorHex(stepColor: string): string {
  const probe = document.createElement("div");
  probe.style.color = `var(--${stepColor}-600)`;
  probe.style.display = "none";
  document.body.appendChild(probe);
  const color = getComputedStyle(probe).color;
  probe.remove();
  const ctx = document.createElement("canvas").getContext("2d");
  if (!ctx) return color;
  ctx.fillStyle = color;
  return String(ctx.fillStyle);
}
